module.exports = __webpack_public_path__ + "img/mail-privacy.4196682d.png";